var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3281 1.66797C12.3281 1.66797 14.1615 1.83464 16.4948 4.16797C18.8281 6.5013 18.9948 8.33464 18.9948 8.33464",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.61328C12.5 4.61328 13.325 4.84898 14.5624 6.08642C15.7998 7.32386 16.0355 8.14882 16.0355 8.14882",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03132 4.42884L9.57217 5.39795C10.0603 6.27252 9.86432 7.4198 9.09559 8.18853C9.09559 8.18853 9.09559 8.18853 9.09559 8.18853C9.09548 8.18865 8.16325 9.12109 9.85376 10.8116C11.5436 12.5015 12.476 11.5706 12.4768 11.5698C12.4769 11.5698 12.4768 11.5698 12.4769 11.5697C13.2456 10.801 14.3929 10.6051 15.2674 11.0932L16.2365 11.634C17.5571 12.3711 17.7131 14.2231 16.5523 15.3839C15.8548 16.0814 15.0003 16.6241 14.0558 16.6599C12.4656 16.7202 9.76523 16.3178 7.05642 13.6089C4.34761 10.9001 3.94518 8.19972 4.00546 6.6096C4.04127 5.66503 4.584 4.81056 5.2815 4.11306C6.4423 2.95227 8.29431 3.10823 9.03132 4.42884Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.562a25652052a6da4c54099e7b017f02.svg";
export { ForwardRef as ReactComponent };